import facilitiesWide from "../../assets/company/facilities/facilitiesWide.png";
import facilities2 from "../../assets/company/facilities/facilities-2.png";
import facilities3 from "../../assets/company/facilities/facilities-3.png";
import facilitiesMain from "../../assets/company/facilities/facilities-main.png";
import lab1 from "../../assets/company/facilities/lab1.png";

import React from "react";
import { Link } from "react-router-dom";

export const facilitiesData = {
  title: "The Hive",
  heroCards: [
    {
      title: "7,000 sq ft Facility",
      description: "Purpose-built for developing, integrating, and testing prototype assemblies and spaceflight hardware",
    },
    {
      title: "State-of-the-Art Equipment",
      description: "Machine tools, rapid prototyping systems, large vacuum systems, optical benches, and extensive electrical test gear",
    },
    {
      title: "Agile Engineering",
      description: "Designed for rapid iteration and testing of cutting-edge space technologies from concept to flight-ready hardware",
    },
  ],
  content: [
    {
      href: facilitiesWide,
    },
    {
      title: "Advanced Manufacturing Capabilities",
      cards: [
        {
          title: "Machine Shop",
          description: "Full machine shop with CNC mills, lathes, and precision tooling for custom hardware fabrication",
        },
        {
          title: "Rapid Prototyping",
          description: "3D printing systems and additive manufacturing for quick iteration and testing of new designs",
        },
        {
          title: "Electronics Lab",
          description: "Extensive electrical test equipment for circuit development, testing, and validation",
        },
      ],
      href: facilities2,
    },
    {
      title: "Testing Infrastructure",
      cards: [
        {
          title: "Vacuum Systems",
          description: "Large vacuum chambers for testing hardware in simulated space environments",
        },
        {
          title: "Optical Benches",
          description: "Precision optical testing facilities for telescope and sensor system development",
        },
        {
          title: "Integration Bays",
          description: "Dedicated areas for assembling and testing complete flight systems before deployment",
        },
      ],
      href: facilities3,
    },
    {
      title: "Technologies Developed At The Hive",
      cards: [
        {
          title: (
            <>
              <Link className="link" to="/capabilities/detecting">
                Sutter™ Telescopes
              </Link>
            </>
          ),
          description: "Advanced telescope systems for space domain awareness and asteroid detection",
        },
        {
          title: (
            <>
              <Link className="link" to="/capabilities/capturing">
                Capture Bag™
              </Link>
            </>
          ),
          description: "Innovative capture system for asteroid retrieval and space debris management",
        },
        {
          title: (
            <>
              <Link className="link" to="/capabilities/moving">
                Omnivore™ Thruster
              </Link>
            </>
          ),
          description: "Revolutionary propulsion system developed and tested at The Hive for in-space operations",
        },
        {
          title: (
            <>
              <Link className="link" to="/products/daqastra">
                DAQAstra™
              </Link>
            </>
          ),
          description: "Advanced data acquisition and control system for space operations and mission management",
        },
      ],
      href: lab1,
    },
  ],
};

